import { redirect, type ParsedLocation } from '@tanstack/react-router';
import { useAuthStore } from '../../stores/auth.js';

export function requireAuth({ location }: { location: ParsedLocation }) {
  const { accessToken } = useAuthStore.getState();
  if (!accessToken) {
    throw redirect({
      to: '/login',
      search: { redirect: location.href },
    });
  }
}

export function requireGuest() {
  const { accessToken } = useAuthStore.getState();
  if (accessToken) {
    throw redirect({ to: '/' });
  }
}

export function isSafeRedirect(href: string | undefined): href is string {
  if (!href) return false;
  return href.startsWith('/') && !href.startsWith('//');
}
